import { CONVERSATION_MODES } from '../constants/modes';

import type { ConversationMode } from '../constants/modes';

type Translate = (key: string, options?: Record<string, unknown>) => string;

type NoticeKeys = {
  body: string;
  title: string;
};

export type QuotaExhaustedNotice = {
  body: string;
  title: string;
};

const GENERAL_NOTICE_KEYS: NoticeKeys = {
  body: 'chatbot:quota_exhausted_body',
  title: 'chatbot:quota_exhausted_title',
};

// En revisión el mensaje remite al botón «Ver mi respuesta» de la página de la pregunta. De aquí
// leen tanto la burbuja como su anuncio para el lector de pantalla.
const NOTICE_KEYS_BY_MODE: Partial<Record<ConversationMode, NoticeKeys>> = {
  [CONVERSATION_MODES.REVISION]: {
    body: 'chatbot:quota_exhausted_revision_body',
    title: 'chatbot:quota_exhausted_title',
  },
};

export function getQuotaExhaustedNotice(t: Translate, mode: ConversationMode): QuotaExhaustedNotice {
  const keys = NOTICE_KEYS_BY_MODE[mode] ?? GENERAL_NOTICE_KEYS;
  // Cada botón se nombra con su propia clave para que, si cambia su etiqueta, cambie también el
  // mensaje. Cada cuerpo usa solo la suya: i18next ignora el resto.
  return {
    body: t(keys.body, { recents: t('chatbot:Recents'), viewMyAnswer: t('chatbot:practice_button_view_my_answer') }),
    title: t(keys.title),
  };
}

export function formatQuotaExhaustedNotice(t: Translate, mode: ConversationMode): string {
  const { body, title } = getQuotaExhaustedNotice(t, mode);
  return `${title} ${body}`;
}
